import { deepStory } from "@/mocks/gua";

export default function DeepDive() {
  return (
    <section className="mx-auto max-w-6xl px-4 pt-12 md:px-6 md:pt-16">
      <div className="mb-6">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
          <i className="ri-search-line" /> {deepStory.tag}
        </span>
        <h3 className="mt-4 max-w-3xl text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
          {deepStory.title}
        </h3>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-foreground-700 md:text-[15px] md:leading-7">
          {deepStory.lead}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div className="rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
          <ol className="relative space-y-0">
            {deepStory.steps.map((s, i) => (
              <li key={s.id} className="relative flex gap-4 pb-6 last:pb-0">
                {i < deepStory.steps.length - 1 && (
                  <span className="absolute left-[7px] top-5 h-full w-px bg-background-200" />
                )}
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50" />
                <div>
                  <span className="text-xs font-semibold text-accent-600">{s.time}</span>
                  <p className="mt-0.5 text-sm font-bold text-foreground-950">{s.title}</p>
                  <p className="mt-1 text-sm leading-6 text-foreground-700">{s.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="flex flex-col justify-between gap-6 rounded-xl border border-primary-100 bg-primary-50/70 p-6 md:p-8">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-focus-3-line" /> 本期小结
            </span>
            <p className="mt-4 text-[15px] font-medium leading-7 text-foreground-800">
              {deepStory.verdict}
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <a href="#" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800">
              收起这条深挖 <i className="ri-arrow-right-line" />
            </a>
            <span className="inline-flex items-center gap-1 text-xs text-foreground-600">
              <i className="ri-history-line" /> 进展追踪中 · 持续更新
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}